import _ from "lodash";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Alert as Alert2, Col, Input, Row, Table } from "reactstrap";
import { DesktopContainer } from "../layouts";
import { api } from "../utils";
import { ItemDropdownMenu, Pager, ServiceThreadSpinner } from "./";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function TareCheck(props) {
  const [displayOption, setDisplayOption] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [excludeSmallDiff, setExcludeSmallDiff] = useState(false);
  const [itemClass, setItemClass] = useState(null);
  const [itemClasses, setItemClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [screenFields, setScreenFields] = useState({
    summaryList: [],
    sortDirection: "asc",
    sortField: "",
    page: {
      number: 1,
      size: 25,
      total: 0,
      summaryListPrestine: [],
    },
  });

  const BOM_DISPLAYS = [
    { label: "--- All BOMs ---", value: 0 },
    { label: "Tare MATCHES Pkg Totals", value: 1 },
    { label: "Tare does NOT match Pkg Totals", value: 2 },
  ];
  const editBOMId = editItem ? editItem.bomId : null;

  useEffect(() => {
    api
      .fetch("Reference/GetBOMItemClasses")
      .then((response) => {
        let classList = _.map(response.data.itemClasses, (m) => {
          m.value = m.itemClassCode;
          m.label = m.itemClassDescription;
          return m;
        });
        classList.unshift({ label: "--- All Classes ---", value: "" });
        setItemClasses(classList);
      })
      .catch((error) =>
        setMessage({
          flavor: "alert-danger",
          text: "There was an error loading the drop down list data",
        })
      );
  }, []);

  useEffect(() => {
    if (!displayOption || loading) return;
    setLoading(true);
    api
      .post("BOM/GetTareCheckSummary", CreadePayload())
      .then((r) => {
        // _.map(r.data.tareSummary)
        if (r.data.success) {
          setEditItem(null);
          api
            .post("BOM/GetTareCheckSummary", CreadePayload())
            .then((r) => {
              // eslint-disable-next-line no-unused-vars
              const copy = _.cloneDeep(screenFields);
              let data = r.data?.tareSummary;
              if (data.length > 25) {
                PaginateList({
                  number: 1,
                  size: 25,
                  summaryListPrestine: data,
                });
              } else {
                PaginateList({
                  number: 1,
                  size: 25,
                  summaryListPrestine: data,
                });
                // setScreenFields({
                //   ...copy,
                //   summaryList: r.data.tareSummary
                // });
              }
            })
            .catch(api.catchHandler)
            .finally(() => setLoading(false));
        } else {
          setMessage({
            flavor: "alert-warning",
            text: r.data.message,
          });
        }
        // setScreenFields({
        //   ...screenFields,
        //   summaryList: r.data.tareSummary
        // });
      })
      .catch(api.catchHandler)
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayOption, itemClass, excludeSmallDiff]);

  useEffect(() => {
    setMessage(null);
  }, [editItem]);

  function commitEdits() {
    if (!editItem) return;
    if (!editItem.parentTare) {
      setMessage({
        flavor: "alert-danger",
        text: "Provide a valid tare weight in order to save.",
      });
    }
    if (loading) return;
    setLoading(true);
    api
      .post("BOM/SaveTare", {
        itemNumber: editItem.parent,
        tareWeight: editItem.parentTare,
      })
      .then((r) => {
        if (r.data.success) {
          setEditItem(null);
          api
            .post("BOM/GetTareCheckSummary", CreadePayload())
            .then((r) => {
              const copy = _.cloneDeep(screenFields);
              let data = r.data?.tareSummary;
              if (data.length > 25) {
                PaginateList({
                  number: 1,
                  size: 25,
                  summaryListPrestine: data,
                });
              } else {
                setScreenFields({
                  ...copy,
                  summaryList: r.data.tareSummary,
                  // page: {
                  //   number: 1,
                  //   size: 25,
                  //   total: 0,
                  //   summaryListPrestine: []
                  // },
                });
              }
            })
            .catch(api.catchHandler)
            .finally(() => setLoading(false));
        } else {
          setMessage({
            flavor: "alert-warning",
            text: r.data.message,
          });
        }
      })
      .catch(api.catchHandler);
  }

  function CreadePayload() {
    return {
      BOMDisplayType: displayOption.value,
      ItemClass:
        itemClass && itemClass.itemClassCode ? itemClass.itemClassCode : null,
      ExcludeSmallDiff: excludeSmallDiff,
    };
  }

  const pageSpecificSorting = (state) => {
    const { sortField, sortDirection } = state;
    const data = _.orderBy(
      screenFields.summaryList,
      [sortField],
      [sortDirection]
    );

    setScreenFields({
      ...screenFields,
      sortDirection: sortDirection,
      sortField: sortField,
      summaryList: data,
    });
  };

  const PaginateList = ({
    number = 1,
    size = 25,
    summaryListPrestine = [],
  }) => {
    const totalLength = summaryListPrestine.length;
    const copy = _.cloneDeep(screenFields);
    const Number = number;
    const Total = _.ceil(totalLength / size);
    const List = _.chain(summaryListPrestine)
      .drop(size * (number - 1))
      .take(size)
      .value();
    const Size = size;
    setScreenFields({
      ...copy,
      summaryList: List,
      page: {
        summaryListPrestine: summaryListPrestine,
        number: Number,
        size: Size,
        total: Total,
      },
    });
  };

  return (
    (document.title = `Tare Checks`),
    (
      <DesktopContainer screenName="Tare Checks">
        <ServiceThreadSpinner on={loading}>
          {message ? (
            <Row className="mt-3">
              <Col>
                <Alert2 className={message.flavor}>{message.text}</Alert2>
              </Col>
            </Row>
          ) : null}
          <div className="filter-header mb-3">
            <Row>
              <Col xs={12}>
                <Row className="align-items-center my-1">
                  <Col xs={3}>
                    <h5 children="Display:" className="float-end text-white" />
                  </Col>
                  <Col xs={6}>
                    <Select
                      classNamePrefix="serviceThreadSelect"
                      closeMenuOnSelect={true}
                      components={makeAnimated()}
                      options={BOM_DISPLAYS}
                      onChange={setDisplayOption}
                      value={displayOption}
                    />
                  </Col>
                </Row>
                <Row className="align-items-center my-1">
                  <Col xs={3}>
                    <h5
                      children="Item Class:"
                      className="float-end text-white"
                    />
                  </Col>
                  <Col xs={6}>
                    <Select
                      classNamePrefix="serviceThreadSelect"
                      closeMenuOnSelect={true}
                      components={makeAnimated()}
                      options={itemClasses}
                      onChange={setItemClass}
                      value={itemClass}
                    />
                  </Col>
                </Row>
                <Row className="text-white my-2">
                  <Col xs={{ size: 9, offset: 3 }}>
                    <Input
                      type="checkbox"
                      checked={excludeSmallDiff}
                      className="ms-1"
                      onChange={() => setExcludeSmallDiff(!excludeSmallDiff)}
                    />
                    <span className="ps-3">
                      Exclude items where Tare Difference &lt; 1
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          {screenFields?.summaryList && screenFields.summaryList.length ? (
            <Row>
              <Col xs={{ size: 8, offset: 2 }}>
                <Table size="sm" className="data-table">
                  <thead className="table-header">
                    <tr>
                      <th>
                        <PageSpecificSortHeader
                          displayName={"Parent Item"}
                          field={"parent"}
                          sortDirection={screenFields.sortDirection}
                          sorted={screenFields.sortField === "parent"}
                          callback={pageSpecificSorting}
                          state={{
                            sortField: "parent",
                            sortDirection:
                              screenFields.sortDirection === "asc"
                                ? "desc"
                                : "asc",
                          }}
                        />
                      </th>
                      <th>
                        <PageSpecificSortHeader
                          displayName={"Tare Weight"}
                          field={"parentTare"}
                          sortDirection={screenFields.sortDirection}
                          sorted={screenFields.sortField === "parentTare"}
                          callback={pageSpecificSorting}
                          state={{
                            sortField: "parentTare",
                            sortDirection:
                              screenFields.sortDirection === "asc"
                                ? "desc"
                                : "asc",
                          }}
                        />
                      </th>
                      <th>
                        <PageSpecificSortHeader
                          displayName={"Total Pkg Wgt"}
                          field={"totalPkgWeight"}
                          sortDirection={screenFields.sortDirection}
                          sorted={screenFields.sortField === "totalPkgWeight"}
                          callback={pageSpecificSorting}
                          state={{
                            sortField: "totalPkgWeight",
                            sortDirection:
                              screenFields.sortDirection === "asc"
                                ? "desc"
                                : "asc",
                          }}
                        />
                      </th>
                      <th>
                        <PageSpecificSortHeader
                          displayName={"+/- Diff"}
                          field={"tareDifference"}
                          sortDirection={screenFields.sortDirection}
                          sorted={screenFields.sortField === "tareDifference"}
                          callback={pageSpecificSorting}
                          state={{
                            sortField: "tareDifference",
                            sortDirection:
                              screenFields.sortDirection === "asc"
                                ? "desc"
                                : "asc",
                          }}
                        />
                      </th>
                      <th colSpan="2"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {_.map(screenFields.summaryList, (b, index) => (
                      <tr
                        key={`b${index}-${b.bomid}`}
                        className={`tr-${index % 2 === 0 ? "primary" : "secondary"
                          }`}
                      >
                        <ItemDropdownMenu
                          itemNumber={b.parent}
                          itemDescription={b.itemWithDesc}
                          attachmentCount={b.itemAttachmentCount}
                        />
                        <td>
                          {editBOMId === b.bomId ? (
                            <Input
                              bsSize="sm"
                              type="number"
                              style={{ width: "100px" }}
                              value={editItem.parentTare}
                              onChange={(e) =>
                                setEditItem({
                                  ...editItem,
                                  parentTare: e.target.value,
                                })
                              }
                            />
                          ) : (
                            b.parentTare
                          )}
                        </td>
                        <td>{b.totalPkgWeight}</td>
                        <td>{b.tareDifference}</td>
                        {editBOMId === b.bomId ? (
                          <>
                            <td
                              className="boldedOrange cursor-pointer"
                              onClick={commitEdits}
                            >
                              Update
                            </td>
                            <td
                              className="boldedOrange cursor-pointer"
                              onClick={() => setEditItem(null)}
                            >
                              Cancel
                            </td>
                          </>
                        ) : (
                          <td
                            colSpan="2"
                            className="boldedOrange cursor-pointer"
                            onClick={() => setEditItem(b)}
                          >
                            Edit
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <Pager
                  callBack={(number) =>
                    PaginateList({ ...screenFields?.page, number: number })
                  }
                  sizeCallback={(size) =>
                    PaginateList({ ...screenFields?.page, size: size })
                  }
                  pageNumber={screenFields.page?.number}
                  pageSize={screenFields.page?.size}
                  totalPages={screenFields.page?.total}
                  className={"float-start justify-content-center"}
                />
              </Col>
            </Row>
          ) : null}
        </ServiceThreadSpinner>
      </DesktopContainer>
    )
  );
}

function PageSpecificSortHeader(props) {
  const [direction, setDirection] = useState(props.sortDirection || "asc");
  const callBackDir = direction === "desc" ? "asc" : "desc";

  useEffect(() => {
    setDirection(props.sortDirection || "asc");
  }, [props.sortDirection]);

  return (
    <span
      className="sort-handle"
      onClick={() =>
        props.state
          ? props.callback(props.state)
          : props.callback(props.field, callBackDir)
      }
    >
      {props.displayName}
      {props.sorted && direction === "asc" && (
        <FontAwesomeIcon icon="angle-up" className="ms-1" />
      )}
      {props.sorted && direction === "desc" && (
        <FontAwesomeIcon icon="angle-down" className="ms-1" />
      )}
    </span>
  );
}
